export function Alea(...args) {
    // Johannes Baagøe <baagoe@baagoe.com>, 2010
    let s0 = 0;
    let s1 = 0;
    let s2 = 0;
    let c = 1;

    if (args.length == 0) {
        args = [+new Date];
    }

    {
        let mash = Mash();
        s0 = mash(' ');
        s1 = mash(' ');
        s2 = mash(' ');
        for (let i = 0; i < args.length; ++i) {
            s0 -= mash(args[i]);
            if (s0 < 0) {
                s0 += 1;
            }
            s1 -= mash(args[i]);
            if (s1 < 0) {
                s1 += 1;
            }
            s2 -= mash(args[i]);
            if (s2 < 0) {
                s2 += 1;
            }
        }
    }

    const random = function() {
        const t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
        s0 = s1;
        s1 = s2;
        return s2 = t - (c = t | 0);
    };

    random.uint32 = function() {
        return random() * 0x100000000; // 2^32
    };

    random.fract53 = function() {
        return random() + 
            (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
    };

    const {sqrt, log, cos, PI} = Math;

    random.gauss = function(mu=0.0, sigma=1.0) {
        const u = 1.0 - random(); // converting [0,1) to (0,1]
        const v = random();
        const z = sqrt(-2.0 * log(u)) * cos(2.0 * PI * v);
        return z * sigma + mu;
    };

    random.expovariate = (mu=1) => -Math.log(1 - random()) * mu;

    random.args = args;
    return random;
}

function Mash() {
    let n = 0xefc8249d;
    return function(data) {
        data = data.toString();
        for (let i = 0; i < data.length; i++) {
            n += data.charCodeAt(i);
            let h = 0.02519603282416938 * n;
            n = h >>> 0;
            h -= n;
            h *= n;
            n = h >>> 0;
            h -= n;
            n += h * 0x100000000; // 2^32
        }
        return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
    };
}

